module.exports = __webpack_public_path__ + "b7beed48bf82fad4545940848cca0384.pdf";